import { useEffect, useState } from "react";
import { get, ref } from "firebase/database";
import { db } from "../lib/firebase";
import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

/**
 * Reads `agencies/${agencyID}/isAppSumo` from RTDB when the logged-in user is available.
 */
const useAgencyIsAppSumo = () => {
  const dispatch = useDispatchApp();
  const authUser = useSelectorApp((state) => state.auth.user);
  const [isAppSumo, setIsAppSumo] = useState(false);
  const [isAppSumoResolved, setIsAppSumoResolved] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const { agencyID } = dispatch(getPathDatabaseByRole());

      if (!agencyID) {
        if (!cancelled) {
          setIsAppSumo(false);
          setIsAppSumoResolved(Boolean(authUser?.uid));
        }
        return;
      }

      try {
        const snapshot = await get(ref(db, `agencies/${agencyID}/isAppSumo`));
        if (!cancelled) {
          setIsAppSumo(snapshot.val() === true);
          setIsAppSumoResolved(true);
        }
      } catch {
        if (!cancelled) {
          setIsAppSumo(false);
          setIsAppSumoResolved(true);
        }
      }
    };

    if (!authUser?.uid) {
      setIsAppSumo(false);
      setIsAppSumoResolved(false);
      return () => {
        cancelled = true;
      };
    }

    setIsAppSumoResolved(false);
    run();

    return () => {
      cancelled = true;
    };

    // eslint-disable-next-line
  }, [authUser?.agencyID]);

  return { isAppSumo, isAppSumoResolved };
};

export default useAgencyIsAppSumo;
